(function() {
    'use strict';

    angular
        .module('app')
        .controller('optionSelectorController', optionSelectorController);

    function optionSelectorController($rootScope, $scope, $uibModalInstance, keyValueList, titleTranslate,isCycle) {
        var vm = this;
        vm.cancel = cancel;
        vm.dataSelected = dataSelected;
        vm.title = titleTranslate;
        vm.isCycle = isCycle;
        onInit();
        $scope.list = GetList(keyValueList);

        function onInit() {
            dataInit();
        }

        function dataInit() {
            vm.isKeyValueList = false;
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function GetList(keyValueList) {
            //console.log('GetList:',keyValueList);
            var list = [];
            if (Object.prototype.isPrototypeOf(keyValueList[0]) && !vm.isCycle) {
                for (var i = 0; i <= keyValueList.length - 1; i++) {
                    list.push({ id: keyValueList[i].id, name: keyValueList[i].name });
                }
                vm.isKeyValueList = true;
               // console.log('result:',list);
                return list;
            //}else if(vm.isCycle){
                // for (var i = 0; i <= keyValueList.length - 1; i++) {
                //     list.push({ value: keyValueList[i].id, name: keyValueList[i].name });
                // }
                // vm.isKeyValueList = true;
                // console.log('result:',list);
                // return list;
            }else {
                //console.log('result:',keyValueList);
                return keyValueList;
            }
        }

        function dataSelected(data) {
            $uibModalInstance.close(data);
        }

    }
})();